import React, { useEffect, useState } from "react";
import Style from "../../style/Pages/User&RoleCreateUpdate.module.css";
import mainStyle from "../../style/Main.module.css";
import popupsyle from "../../style/PopUp.module.css";
import EditStyle from "../../style/Pages/EditPage.module.css";
import { useEditusrandRole } from "../../hooks/useUser&role";
import Loader from "../../components/ui/Loader/Loader";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import { MultiSelect } from "react-multi-select-component";
import { useFetchUserCompany } from "../../hooks/useCommonHooks";

const EditUserandRole = ({ show, onClose, data }) => {
  const { formData, loading, error, setFormData, setError, handleSubmit } =
    useEditusrandRole(onClose);
  const [selectedUserId, setselectedUserId] = useState(null);

  const [selectedCompanies, setSelectedCompanies] = useState([]); // <-- NEW state
  const companyList = useFetchUserCompany(selectedUserId);

  const companyOptions = companyList.map((company) => ({
    label: company.company_name,
    value: company.id,
  }));

  const handleCompanyChange = (options) => {
    setSelectedCompanies(options || []); // store multi-selected companies

    setFormData((prev) => ({
      ...prev,
      access_company: options.map((o) => o.value), // store company IDs
    }));

    setError((prev) => ({ ...prev, access_company: "" }));
  };
  const handlePermissionChange = (category, permissionType) => {
    const updatedCategory = {
      ...formData.access_details[category],
      [permissionType]: !formData.access_details[category][permissionType],
    };

    // Rule: If add/edit/active_deactive is true, view must be true
    if (permissionType !== "view" && updatedCategory[permissionType] === true) {
      updatedCategory.view = true;
    }

    // Rule: If all (add/edit/active_deactive) are false, view can be toggled independently
    if (
      permissionType === "view" &&
      updatedCategory.view === false &&
      (updatedCategory.add ||
        updatedCategory.edit ||
        updatedCategory.active_deactive)
    ) {
      // Prevent turning off view if other permissions are enabled
      updatedCategory.view = true;
    }

    const updatedPermissions = {
      ...formData.access_details,
      [category]: updatedCategory,
    };

    // Clear error if at least one permission is selected
    const hasPermissions = Object.values(updatedPermissions).some((category) =>
      Object.values(category).some((permission) => permission)
    );

    if (hasPermissions && error.access_details) {
      setError((prev) => {
        const newErrors = { ...prev };
        delete newErrors.access_details;
        return newErrors;
      });
    }

    setFormData((prev) => ({
      ...prev,
      access_details: updatedPermissions,
    }));
  };

  useEffect(() => {
    if (data && data.access_details) {
      const convertedAccessDetails = {
        user: {
          //   ...defaultPermissions,
          view: data.access_details.user?.includes?.("view") || false,
          edit: data.access_details.user?.includes?.("edit") || false,
          active_deactive:
            data.access_details.user?.includes?.("active_deactive") || false,
          add: data.access_details.user?.includes?.("add") || false,
        },
        group: {
          //   ...defaultPermissions,
          active_deactive:
            data.access_details.group?.includes?.("active_deactive") || false,
          view: data.access_details.group?.includes?.("view") || false,
          edit: data.access_details.group?.includes?.("edit") || false,
          add: data.access_details.group?.includes?.("add") || false,
        },
        // Initialize other categories with default permissions
        // user: { ...defaultPermissions },
        channel: {
          active_deactive:
            data.access_details.channel?.includes?.("active_deactive") || false,
          view: data.access_details.channel?.includes?.("view") || false,
          edit: data.access_details.channel?.includes?.("edit") || false,
          add: data.access_details.channel?.includes?.("add") || false,
        },
        // company: {
        //   active_deactive:
        //     data.access_details.company?.includes?.("active_deactive") || false,
        //   view: data.access_details.company?.includes?.("view") || false,
        //   edit: data.access_details.company?.includes?.("edit") || false,
        //   add: data.access_details.company?.includes?.("add") || false,
        // },
      };
      const companyid = data.access_company.map((acc) => acc.id);
      setFormData((prev) => ({
        ...prev,
        access_details: convertedAccessDetails,
        id: data.id,
        access_company: companyid,
        register: data.register,
      }));
      const selectedOptions = data.access_company.map((acc) => ({
        label: acc.company_name,
        value: acc.id,
      }));
      setselectedUserId(data.register);
      setSelectedCompanies(selectedOptions);
    }
  }, [data, setFormData]);

  const handleClose = () => {
    onClose();
  };

  if (!show) return null;

  return (
    <div className={popupsyle.popupBackground}>
      <div className={EditStyle.editPopupContainer}>
        <div className={popupsyle.PopupContainer}>
          <div className={popupsyle.popupHeader}>
            <h3>Edit User Access</h3>

            {/* <TfiClose
              onClick={onClose}
              size={20}
              className={popupsyle.closePopup}
            /> */}
          </div>
          <div className={popupsyle.popupContent}>
            <p className={mainStyle.contentGuideOrd}>
              Note : You can update and manage user access here to control what
              each user can view, add, edit, or activate. Regular updates help
              maintain security and proper role-based access.
            </p>
            <div className={mainStyle.mainInputDiv}>
              <label htmlFor="text" className={PageInputStyle.label}>
                Company<span className={mainStyle.mantitory}>*</span>
              </label>
              {/* <Select
                    className={mainStyle.selectBoxPage}
                    options={companyOptions}
                    value={companyOptions.find(
                      (option) => option.value === formData.access_company
                    )}
                    onChange={handleCompanyChange}
                    isClearable={false} // This removes the clear symbol
                  /> */}

              <MultiSelect
                options={companyOptions}
                value={selectedCompanies} // <-- use selectedCompanies state
                onChange={handleCompanyChange}
                labelledBy="Select Companies"
                className={mainStyle.mutiSelectDropDown}
                disabled={!formData.register} // <-- disable until user is selected
                overrideStrings={{
                  allItemsAreSelected: "All companies selected",
                  selectSomeItems: "Select Companies",
                }}
              />
              {error.access_company && (
                <span className={mainStyle.errorMsg}>
                  {error.access_company}
                </span>
              )}
            </div>
            <div>
              <label htmlFor="text" className={PageInputStyle.label}>
                Access Category
                <span className={mainStyle.mantitory}>*</span>
              </label>
              {error.access_details && (
                <span className={mainStyle.errorMsg}>
                  {error.access_details}
                </span>
              )}
            </div>
            <div>
              <table className={Style.permissionsTable}>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>View</th>
                    <th>Add</th>
                    <th>Edit</th>
                    <th>Active/Deactive</th>
                  </tr>
                </thead>
                <tbody>
                  {["user", "group", "channel"].map((category) => (
                    <tr key={category}>
                      <td>
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                      </td>
                      <td>
                        <label className={Style.toggleSwitch}>
                          <input
                            type="checkbox"
                            checked={
                              formData.access_details[category]?.view || false
                            }
                            onChange={() =>
                              handlePermissionChange(category, "view")
                            }
                          />
                          <span className={Style.toggleSlider}></span>
                        </label>
                      </td>
                      <td>
                        <label className={Style.toggleSwitch}>
                          <input
                            type="checkbox"
                            checked={
                              formData.access_details[category]?.add || false
                            }
                            onChange={() =>
                              handlePermissionChange(category, "add")
                            }
                          />
                          <span className={Style.toggleSlider}></span>
                        </label>
                      </td>
                      <td>
                        <label className={Style.toggleSwitch}>
                          <input
                            type="checkbox"
                            checked={
                              formData.access_details[category]?.edit || false
                            }
                            onChange={() =>
                              handlePermissionChange(category, "edit")
                            }
                          />
                          <span className={Style.toggleSlider}></span>
                        </label>
                      </td>
                      <td>
                        <label className={Style.toggleSwitch}>
                          <input
                            type="checkbox"
                            checked={
                              formData.access_details[category]
                                ?.active_deactive || false
                            }
                            onChange={() =>
                              handlePermissionChange(
                                category,
                                "active_deactive"
                              )
                            }
                          />
                          <span className={Style.toggleSlider}></span>
                        </label>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className={popupsyle.popupButtonDiv}>
            <div className={popupsyle.actionButtons}>
              <button className={popupsyle.cancelButton} onClick={handleClose}>
                Cancel
              </button>
              <button
                className={popupsyle.updateButton}
                onClick={handleSubmit}
                // disabled={loader}
              >
                {loading ? <Loader /> : "Update"}
                {/* {loader ? (
                  <div className={styles.spinner}></div>
                ) : (
                  "Delete Logs"
                )} */}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserandRole;
